import { useState } from 'react';
import { SignOutModal } from 'restaurantAdmin/auth/SignOutModal';
import { ErrorHero } from './ErrorHero';

export const ErrorNoRestaurants = () => {
  const [isSignOutModalOpen, setIsSignOutModalOpen] = useState(false);

  const closeSignOutModal = () => {
    setIsSignOutModalOpen(false);
  };

  return (
    <div>
      <ErrorHero
        title="No Restaurants"
        subtitle="Sorry, you do not have any active restaurants."
        onSignOut={() => setIsSignOutModalOpen(true)}
      />
      <SignOutModal
        closeModal={closeSignOutModal}
        isOpen={isSignOutModalOpen}
      />
    </div>
  );
};
